import { render } from "./GrLayoutTemplate.vue?vue&type=template&id=4baa777a&scoped=true"
import script from "./GrLayoutTemplate.vue?vue&type=script&lang=js"
export * from "./GrLayoutTemplate.vue?vue&type=script&lang=js"

import "./GrLayoutTemplate.vue?vue&type=style&index=0&id=4baa777a&scoped=true&lang=css"

import exportComponent from "/var/www/greenified-mono-staging/ims.greenified.se/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4baa777a"]])

export default __exports__